module.exports = __webpack_public_path__ + "img/b10.021fbe27.png";